import { render, staticRenderFns } from "./BaseMobileLayout.vue?vue&type=template&id=121b8c4a&scoped=true"
import script from "./BaseMobileLayout.vue?vue&type=script&lang=js"
export * from "./BaseMobileLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121b8c4a",
  null
  
)

export default component.exports